// extracted by mini-css-extract-plugin
module.exports = {"WishlistIcon":"styles_WishlistIcon__OPvG6","hasInteracted":"styles_hasInteracted__H1Ull","icon":"styles_icon__aYXn4","isActive":"styles_isActive__F_4t_"};